var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt001ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dataliteracy_color_diamond",
    transform: "translate(-620.834 -716.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-ot-pathwayNodeBackground-ot-pc-DataScienceLiteracy-pc-_",
    "data-name": "-ot-pathwayNodeBackground-ot-pc-DataScienceLiteracy-pc- ",
    transform: "translate(620.834 764.834) rotate(-45)",
    fill: "#ced4dd",
    stroke: "#0e2a58",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "assessment_black_24dp_1_",
    "data-name": "assessment_black_24dp (1)",
    transform: "translate(644.792 740.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M0,0H47.917V47.917H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-ot-pathwayNodeIcon-ot-pc-DataScienceLiteracy-pc-_",
    "data-name": "-ot-pathwayNodeIcon-ot-pc-DataScienceLiteracy-pc-  ",
    d: "M34.945,3H6.993A4,4,0,0,0,3,6.993V34.945a4,4,0,0,0,3.993,3.993H34.945a4,4,0,0,0,3.993-3.993V6.993A4,4,0,0,0,34.945,3Zm0,31.945H6.993V6.993H34.945ZM10.986,16.976h3.993V30.952H10.986Zm7.986-5.99h3.993V30.952H18.972Zm7.986,11.979h3.993v7.986H26.958Z",
    transform: "translate(2.99 2.99)",
    fill: "#0e2a58"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt001ColorDiamond);
export default __webpack_public_path__ + "static/media/PT001_color_diamond.5e3f929ba3f283b65d48d6440061b642.svg";
export { ForwardRef as ReactComponent };